<nz-modal [nzVisible]="visible" [nzWidth]="810" (nzOnCancel)="close()" [nzTitle]="''" [nzFooter]="null"
  class="terms-content">
  <ng-container *nzModalContent>
    <div class="terms-content">
      <div class="title" style="font-size: 20px">{{ this.companyNameUpperCase }} TERMS OF SERVICE</div>
      <div class="title yellow-text light-bold" style="font-size: 16px; font-weight: 500 !important">N3 AI ACCOUNTING</div>
      <div style="text-align: justify; margin-top: 10px">
        First of all, we would like to extend our gratitude for choosing {{ this.companyNameLowerCase }} and its
        services as your partner in business. QNE
        Software shall be referred to as "QNE", “{{ this.companyNameLowerCase }}”, "we", "our", and/or "us". Review
        QNE’s Terms of Service or "Agreement"
        thoroughly. This Agreement is a legal agreement between you and {{ this.companyNameLowerCase }}. And by creating
        an account, you are
        indicating acceptance electronically agree to this Agreement. Should you decline and choose not to agree to this
        Agreement, you
        shall then may not use the said services.

        <div class="content">
          <div class="yellow-text subtitle numbering">I.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">AGREEMENT</div>
            By agreeing to the terms of service, you are agreeing to; {{ this.companyNameLowerCase }}’s Privacy Policy
            and other terms provided separately to
            you for the software including its program, services, ordering, activation, payment terms, data processing
            agreements, and more.
            You are also aware that you should be at a legal age to go into agreements and use the said software and its
            services.
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">II.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">COPYRIGHT AND RIGHTS TO USE THE SERVICES</div>
            {{ this.companyNameLowerCase }}’s products and services are protected by copyright, trade secret, and other
            intellectual property laws. You shall
            not remove or destroy any copyright notices, trademarks, or other proprietary markings on {{
            this.companyNameLowerCase }}’s products, software
            documentations or other materials related to the products. You are only granted the right to use the
            Services and only for the
            purposes described by {{ this.companyNameLowerCase }}. You will not take any action that jeopardizes {{
            this.companyNameLowerCase }}’s proprietary rights or acquire
            any right in any of {{ this.companyNameLowerCase }}’s products. QNE reserves all the rights in the services.
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">III.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">PLATFORMS AND DEVICES</div>
            The use of QNE Services may be available through all or any compatible platform such as mobile device,
            tablet, desktop, and/or
            laptop with a web browser. Internet access is also required to use the software. With that, you hereby,
            agree that you are
            solely responsible for these requirements, including any applicable changes, such as updates and fees as
            well as the terms of
            the agreement with your chosen device/s and telecommunications provider.
            <br />
            <br />
            {{ this.companyNameLowerCase }} also assumes no responsibility, warranties, and representations of any kind
            to the availability of the
            telecommunication services in which the services will be accessed; and any security breach or data
            disclosure to other parties.
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">IV.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">SUBSCRIPTION</div>
            N3 AI Accounting is Software as a Service (SaaS) therefor is offered on a subscription basis. Payment
            shall remain on a
            subscription basis may it be monthly or yearly unless stipulated otherwise by QNE in writing.
            <br />
            <div style="margin-left: 35px">
              <div class="yellow-text subtitle">Subscription Plan Charges</div>

              By agreeing to the terms of service, you hereby grant {{ this.companyNameLowerCase }} to; charge you
              automatically with the amount and terms
              (monthly or yearly) stipulated in the agreement, ask for your payment in order to continue using N3 AI Accounting, and
              continuously charge you with the agreed fee or chosen plan and terms until you manually cancel your
              subscription. {{ this.companyNameLowerCase }}
              has no liability and will not process refund in cases when you willingly or unwillingly forgot to manually
              stop or remove your
              subscription.

              <div class="yellow-text subtitle">Subscription Plan Increase</div>

              In an event of price increase with regard to subscription plan fees, you will be notified at least seven
              (7) days before such
              changes will be properly implemented. In that given time-span you have the liberty to either continue or
              cancel your
              subscription to use N3 AI Accounting in accordance to the conditions of this Agreement. If you do not
              agree with the
              stated subscription plan fee changes, you may cancel your subscription anytime in accordance to the
              conditions set forth in
              this Agreement. Should you continue to use N3 AI Accounting without notice of disagreement to the
              price increase, you are
              deemed to have accepted the changes and will be charged accordingly.

              <div class="yellow-text subtitle">Subscription Plan Cancellation</div>

              On cancelling your subscription, you have at your sole discretion the ability to cancel using N3 AI Accounting anytime. By
              cancelling your subscription within its terms, {{ this.companyNameLowerCase }} does not provide refunds
              thus you can still make use of the system
              until the given time of expiration. In addition, failure to process payment in full and/or on-time will be
              subject to
              suspension of use of the N3 AI Accounting. A notice will be given through the system if in any cases
              payment is
              unsuccessful thus the use of the system will be suspended unless paid in full. Any contrary to the set
              payment and
              subscription terms will subject you to automatic cancellation of subscription.
              <br />
              <br />
              {{ this.companyNameLowerCase }} likewise at its sole discretion has the ability to suspend, cancel, or end
              your subscription once proven that you
              have violated any {{ this.companyNameLowerCase }}’s terms of service, company policies, and other known
              agreement.
            </div>
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">V.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">PAYMENT</div>
            QNE shall charge you in accordance to the fees and plans that you have availed in order to continue using
            N3 AI Accounting.
            <br /><br />
            <div class="content" style="margin-left: 25px">
              <div class="numbering">a.</div>
              <div class="sub-content">
                Payment currency shall be based on currency in which you are in the time of purchasing:<br />
                a.1. Philippines – Philippine Peso<br />
                a.2. Malaysia – Malaysian Ringgit<br />
                a.3. Myanmar – U.S. Dollar<br />
              </div>
            </div>
            <div class="content" style="margin-left: 25px">
              <div class="numbering">b.</div>
              <div class="sub-content">
                Payment method shall be any of the following:<br />
                b.1. Cash<br />
                b.2. Bank/Inter-bank Deposit or Bank Transfer<br />
                b.3. Active and Valid Debit Card (Auto Debit)<br />
                b.4. Active and Valid Credit Card (Auto Credit)<br />
                b.5. e-Wallet (Gcash, PayMaya, Paypal, Alipay)<br />
              </div>
            </div>
            <div class="content" style="margin-left: 25px">
              <div class="numbering">c.</div>
              <div class="sub-content">
                Should your payment method and registration information be incomplete, outdated, and inaccurate, {{
                this.companyNameLowerCase }} can and will
                suspend or terminate any use of the said services if QNE was not informed or notified.
              </div>
            </div>
            <div class="content" style="margin-left: 25px">
              <div class="numbering">d.</div>
              <div class="sub-content">
                {{ this.companyNameLowerCase }} will automatically renew your monthly, quarterly, or annual subscription
                Services at the said-currency per
                country, unless the said subscription Services is cancelled or terminated under this Agreement.
              </div>
            </div>
            <div class="content" style="margin-left: 25px">
              <div class="numbering">e.</div>
              <div class="sub-content">
                Any additional renewal or cancellation terms can be provided to you on the discretion of QNE
                Consultants.
              </div>
            </div>
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">VI.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">DATA PRIVACY</div>
            By entering to an Agreement with {{ this.companyNameLowerCase }}, you agree to the privacy policy stated in
            this document.
            <a rel="noopener" target="_blank" href="https://qne.cloud/ph/qne-software-ph-data-privacy-policy/">QNE’s
              Privacy Policy</a>.
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">VII.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">USE OF SERVICE, DISCLAIMER OF WARRANTIES, AND LIMITATION OF LIABILITY
            </div>
            Upon agreeing to QNE’s Terms of Service, all content that includes any form of data and information may it
            be text, graphics,
            videos, audios, software, and works of composition of any kind, that are uploaded, transmitted, posted,
            generated, stored or
            otherwise made available through the QNE System, you are granting {{ this.companyNameLowerCase }} to host
            and use your content. You are hereby
            responsible for any lost or irrecoverable content and {{ this.companyNameLowerCase }} is not responsible for
            any of your unlawful and incorrect
            Content that you submit through our Services.
            <br /><br />
            In no event shall {{ this.companyNameLowerCase }} be liable to the costs of procurement of substitute goods
            or services; lost profits; lost sales
            or business expenditures; investments; or commitments in connection with any business, loss of any goodwill,
            or for any
            indirect, special, incidental, or consequential damages arising out of or related to this contract or use of
            the software or
            documentation, however caused, on any theory of liability, and whether or not {{ this.companyNameLowerCase
            }} has been advised of the possibility
            of such damage might cause you. These limitations shall apply notwithstanding any failure of essential
            purpose of any limited
            remedy
            <br /><br />
            You also agree to the following: (a) conduct business in a manner that reflects favorably at all times on
            products and the good
            name, goodwill and reputation of {{ this.companyNameLowerCase }}; (b) avoid deceptive, misleading or
            unethical practices that are or might be
            detrimental to QNE Software Philippines and QNE Software Philippines services; (c) make no false or
            misleading representations
            with regard to QNE Software Philippines, Inc. and QNE Software Philippines, Inc.’s products; (d) not publish
            or employ, or
            cooperate in the publication or employment of, any misleading or deceptive advertising material with regard
            to QNE Software
            Philippines, Inc. or QNE Software Philippines, Inc.’s products; and (e) make no representations, warrantees
            or guarantees to
            customers or to the trade with respect to the specifications, features or capabilities of QNE Software
            Philippines, Inc.’s
            products that are inconsistent with the literature distributed by QNE Software Philippines, Inc.
            <br /><br />
            {{ this.companyNameLowerCase }} disclaims all other warranties of any kind, either express or implied,
            including, but not limited to, the implied
            warranties of merchantability, fitness for a particular purpose, noninterference, system integration, and
            noninfringement.
            Vendor does not warrant that the software or documentation will meet customer’s needs, or that customer’s
            operation of the same
            will be uninterrupted or error free, or that all nonconformities can or will be corrected.
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">VIII.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">PROPRIETARY RIGHTS</div>
            {{ this.companyNameLowerCase }} system and its source code, patents, copyrights, trade secrets are
            proprietary software of the QNE and are
            protected by copyright and other intellectual property laws. The Software is licensed and not sold. You
            acquire only the right
            to use the Software and do not acquire any rights, express or implied, in the Software. Customer is given
            the right to use the
            software only under certain conditions, and restricted from other uses, and thus not entitled to
            manufacture, assemble, copy,
            reproduce, modify, redistribute, imitate or reverse engineer the software or any of its components or the
            designs thereof.
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">IX.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">TERMINATION</div>
            {{ this.companyNameLowerCase }} can and may, at its sole discretion and without prior notice, deny,
            restrict, or terminate this Agreement and
            suspend its Services, immediately, if {{ this.companyNameLowerCase }} verifies that your use of its Services
            violates this Agreement, subject to
            suspicion of fraud, misuse, illegal or unlawful activity or unauthorized access issues. Upon {{
            this.companyNameLowerCase }}’s notice of the
            termination of its Services, you must immediately stop using its Services and any outstanding payments will
            become due and
            subscription will be forfeited.
          </div>
        </div>

        <div class="content">
          <div class="yellow-text subtitle numbering">X.</div>
          <div class="content-body">
            <div class="yellow-text subtitle">GENERAL</div>
            <div class="content" style="margin-left: 25px">
              <div class="numbering">a.</div>
              <div class="sub-content">
                <strong>Choice of Law.</strong>
                The validity, interpretation, and performance of these this Agreement shall be governed by and construed
                and interpreted in
                accordance with the laws of the Republic of the Philippines, Malaysia, China, and Myanmar. The country
                at the time of the
                purchase shall be the appropriate venue and jurisdiction for the resolution of any disputes hereunder.
                Both parties hereby
                consent to such personal and exclusive jurisdiction.
                <br /><br />
                This Agreement shall inure to the benefit of, and be binding upon, the parties hereto, together with
                their respective
                representatives, successors, and assigns except as otherwise provided herein.
              </div>
            </div>
            <br />
            <div class="content" style="margin-left: 25px">
              <div class="numbering">b.</div>
              <div class="sub-content">
                <strong>Force Majeure.</strong>
                Neither party shall be liable for any delay or failure in performance due to events outside the
                defaulting party’s
                reasonable control, including, without limitation, acts of Nature, earthquakes, labor disputes,
                industry-wide shortages of
                supplies, actions of governmental entities, riots, war, terrorism, fire, epidemics, or delays of common
                carriers or other
                circumstances beyond its reasonable control, provided that the party experiencing the event of Force
                Majeure has prudently
                and promptly acted to take any and all steps that are within the party’s control to ensure performance
                and to shorten the
                duration of the event of Force Majeure. The party suffering an event of Force Majeure shall provide
                notice of the event to
                the other parties when commercially reasonable. Subject to this provision, such non-performance shall
                not be deemed a
                default or a ground for termination. The obligations and rights of the defaulting party shall be
                extended for a period equal
                to the period during which such event prevented such party’s performance but not later than thirty (30)
                calendar days.
              </div>
            </div>
            <br />
            <div class="content" style="margin-left: 25px">
              <div class="numbering">c.</div>
              <div class="sub-content">
                <strong>No Waiver.</strong>
                The waiver by any party hereto of any breach or default shall not constitute a waiver of any different
                or subsequent breach
                or default. No waiver of any provision of this Agreement shall be effective unless stated in writing and
                signed by
                authorized members of all parties
              </div>
            </div>
            <br />
            <div class="content" style="margin-left: 25px">
              <div class="numbering">d.</div>
              <div class="sub-content">
                <strong>Notices.</strong>
                All notices, requests, demands and other communications (collectively, “Notices”) given or made pursuant
                to this Agreement
                shall be in writing and shall be deemed received (i) on the same day if delivered in person, by same-day
                courier or by
                facsimile transmission or by email; provided that if sent by facsimile transmission, a copy is also sent
                by certified mail,
                return receipt requested, postage prepaid, (ii) on the next day if delivered by overnight mail or
                courier, or (iii) five (5)
                business days after the date of deposit in the mails if being sent by certified mail, return receipt
                requested, postage
                prepaid, to the parties at their addresses as set forth at the beginning of this Agreement. Any of the
                parties to this
                Agreement may from time to time change such party’s address for receiving notice by giving written
                notice thereof in the
                manner set forth above.
              </div>
            </div>
            <br />
            <div class="content" style="margin-left: 25px">
              <div class="numbering">e.</div>
              <div class="sub-content">
                <strong>Assignment.</strong>
                Neither these Agreement nor any rights or obligations under these Agreement shall be assigned by a party
                without the other’s
                prior written consent, which will not be unreasonably withheld or delayed. Any attempted assignment
                shall be void and of no
                effect. Notwithstanding the foregoing, the parties may assign these Agreement and any right or
                obligation under it without
                the other’s approval, to any Affiliate. Notwithstanding any assignment by Customer. Customer shall
                remain liable for the
                payment of all amounts due under this Agreement.
              </div>
            </div>
            <br />
            <div class="content" style="margin-left: 25px">
              <div class="numbering">f.</div>
              <div class="sub-content">
                <strong>Relationship of Parties.</strong>
                This Agreement do not create any agency, partnership, joint venture, or franchise relationship. No
                employee of either party
                shall be or become, or shall be deemed to be or become, an employee of the other party by virtue of the
                existence or
                implementation of this Agreement. Each party hereto is an independent contractor. Neither party shall
                assume or create any
                obligation of any nature whatsoever on behalf of the other party or bind the other party in any respect
                whatsoever.
              </div>
            </div>
            <br />
            <div class="content" style="margin-left: 25px">
              <div class="numbering">g.</div>
              <div class="sub-content">
                <strong>Entire Agreement.</strong>
                This Agreement constitutes the entire agreement between the parties concerning the subject matter of
                this Agreement and
                replace any prior oral or written communications between the parties, all of which are excluded. There
                are no conditions,
                understandings, agreements, representations or warranties, expressed or implied, that are not specified
                herein (except where
                implied by law and exclusion is prohibited). This Agreement may be modified only by a written document
                executed by the
                parties hereto.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>
